<template>
  <div class="historyAudit">
    <!-- 标题 -->
    <div class="titleBox flex-row ite-c">
      <b>{{topTitle.title}}</b>
      <span v-show="topTitle.subTit!==''">-{{topTitle.subTit}}</span>
      <span v-show="topTitle.thirdTit!==''">-{{topTitle.thirdTit}}</span>
    </div>

    <!-- tab切换-日期切换 -->
    <ul class="tabBox clearfix">
      <li v-for="(item,index) in tabData.textArr" @click="tabLi(index)" :class="{on:tabData.nowIndex==index}">{{item}}
      </li>
    </ul>

    <!-- 统计（三个模块） -->
    <ul class="totalBox">
      <li class="boxs">
        <div class="total_top">
          <div class="top_le">
                    <span class="top_tit">
                        <img src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/auditInfo2.png' alt="">
                        <span>审核通过</span>
                    </span>
            <span class="top_tip">数据截止当前</span>
          </div>
          <div class="top_ri">
            <img
                    @click="exportDetails(4)"
                    src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportDetail.png' alt="">
          </div>
        </div>
        <div class="total_money lightGText">{{count_data.passTotalFee | centsToYuan}}</div>
      </li>
      <li class="boxs">
        <div class="total_top">
          <div class="top_le">
                    <span class="top_tit">
                        <img src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/auditInfo3.png' alt="">
                        <span>拒绝放款</span>
                    </span>
            <span class="top_tip">数据截止当前</span>
          </div>
          <div class="top_ri">
            <img
                    @click="exportDetails(6)"
                    src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportDetail.png' alt="">
          </div>
        </div>
        <div class="total_money orangeText">{{count_data.rejectTotalFee | centsToYuan}}</div>
      </li>
      <li class="boxs">
        <div class="total_top">
          <div class="top_le">
                    <span class="top_tit">
                        <img src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/auditInfo4.png' alt="">
                        <span>延后处理</span>
                    </span>
            <span class="top_tip">数据截止当前</span>
          </div>
          <div class="top_ri">
            <img
                    @click="exportDetails(8)"
                    src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportDetail.png' alt="">
          </div>
        </div>
        <div class="total_money grayText">{{count_data.delayTotalFee | centsToYuan}}</div>
      </li>
    </ul>

    <div class="titleLine flex-row ite-c"><span>历史审核</span></div>

    <!-- 筛选框 -->
    <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
      <template slot="otherCom">

        <el-form-item>
          <el-select v-model="searchForm.params.status" @change="handleSearch" placeholder="全部状态" size="medium"
                     clearable
                     filterable>
            <el-option v-for="item in statusOptions" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </el-form-item>

        <!--        <el-form-item>-->
        <!--          <el-select v-model="searchForm.auditor" @change="handleSearch" placeholder="所有审核人" size="medium" clearable-->
        <!--                     filterable>-->
        <!--            <el-option v-for="item in auditorOptions" :key="item.key" :label="item.label" :value="item.key"></el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->

        <el-form-item>
          <el-input
                  v-model="searchForm.params.code"
                  placeholder="请输入资金流水ID"
                  @keyup.enter.native="handleSearch"
                  maxlength="25" size="medium" clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-date-picker
                  v-model="timeRange"
                  type="datetimerange"
                  unlink-panels
                  size="medium"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :default-time="['00:00:00', '23:59:59']"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="timePickerOptions"
          >
          </el-date-picker>
        </el-form-item>

      </template>
    </sr-filter>

    <!-- 表格 -->
    <div class="botTable boxs tableTheadGray">
      <div class="tableTop">
        <span class="top_le">审核明细表</span>

        <button class="butStyle pinkBtn exportBtn" @click="tableExport">
          <i class="exportIcon"></i>
          <span>导出</span>
        </button>
      </div>
      <el-table :data="tableData"
                style="width: 100%;"
                max-height="297"
                border
                fit
                highlight-current-row
                tooltip-effect="dark"
      >
        <el-table-column label="资金流水ID" prop="code" min-width="200" header-align="center" align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column label="提现方式" prop="pay_type" width="110" header-align="center" align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.payType.text}}
          </template>
        </el-table-column>
        <el-table-column label="金额（元）" prop="fee" min-width="120" header-align="center" align="right"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.fee | centsToYuan}}
          </template>
        </el-table-column>
        <el-table-column label="手续费（元）" prop="service_charge" min-width="120" header-align="center" align="right"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            0.00
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status_text" min-width="70" header-align="center" align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
                <span :class="{lightGText:scope.row.status.value=='2'}">
                  {{scope.row.status.text}}
                </span>
          </template>
        </el-table-column>
        <el-table-column label="备注信息" prop="note" min-width="180" header-align="center" align="left"
                         show-overflow-tooltip></el-table-column>
        <el-table-column label="审核人" prop="acceptMemberName" min-width="100" header-align="center" align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column label="审核时间" prop="acceptTime" min-width="160" header-align="center" align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column label="提现转账凭证" prop="third_party_sn" width="160" header-align="center" align="right"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <!-- 提现转账凭证-手工加 -->
            <el-button v-if=" !scope.row.certificatePicId "
                       @click="showAddDialog(scope)"
                       type="text"
                       class="lightGText"
                       icon="el-icon-circle-plus-outline"
                       title="点击手工加转账凭证">添加
            </el-button>

            <!-- 提现转账凭证-可编辑 -->
            <el-button v-if="scope.row.certificatePicId "
                       @click="showEditDialog(scope)"
                       type="text"
                       class="greenText"
                       icon="fa fa-pencil"
                       title="点击编辑转账凭证">编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBox boxs">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="searchForm.current" :page-sizes="[10, 20, 30]" :page-size="searchForm.size"
                       layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>


    <!-- 弹窗 -->
    <el-dialog width="375px" :title="dialogMap[dialogTitle]" :visible.sync="dialogFormVisible" @close="closeDialog"
               :before-close="beforeClose" :close-on-click-modal=false :show-close="false">
      <el-form ref="form" :model="postForm" label-width="0px">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="certificatePicId">
              <el-upload
                      class="avatar-uploader"
                      action=""
                      :show-file-list="false"
                      :before-upload="beforeUpload"
                      :on-success="handleUploadSuccess"
                      :on-error="handleUploadError"
                      :http-request="onUpload"
              >
                <!--                <template v-if="uploadedFileId && uploadedFileId!= ''">-->
                <template
                        v-if="(selectedWalletOrder && selectedWalletOrder.certificatePicId && selectedWalletOrder.certificatePicId!= '') || uploadedFileId && uploadedFileId!= ''">
                  <img v-if="selectedWalletOrder.certificatePicId"
                       :src="$variable.getFile(selectedWalletOrder.certificatePicId)"
                       class="avatar">
                  <img v-else-if="uploadedFileId"
                       :src="$variable.getFile(uploadedFileId)"
                       class="avatar">
                </template>
                <template v-else>
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </template>
              </el-upload>

            </el-form-item>
          </el-col>
        </el-row>

      </el-form>

      <span slot="footer" class="dialog-footer flex-row jus-c">
        <button type="button" @click="beforeClose" class="butStyle cancelBtn">取 消</button>
        <button type="button" @click="validateForm" class="butStyle refuseOBtn">确 定</button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import SrFilter from '@/components/Common/Filter/Filter'
  import {formatDate} from '@/utils/dateFormatter';
  import {objectToQueryString} from '@/utils/commonUtils.js';
  import {
    updateMallWalletOrder,
  } from '@/api/Busy/Finance/finance.js';

  import {
    getTotalCount,
    getHisReviewDetails,
    editCertificateAPI
  } from '@/api/Audit/audit.js';

  import {
    uploadFile
  } from '@/api/common.js';

  // 弹窗数据
  const defaultPostForm = {
    certificatePicId: null, // 凭证图片url
    code: null
  }

  // 搜索表格的条件
  const searchConst = {
    // 其他请求参数
    status: null, //状态
    auditor: null, //审核人
    third_party_sn: null, //提现转账流水号
    current: 1, //当前页码
    size: 10, //每页条数
    params: {
      status: null,
      minAcceptTime: null,
      maxAcceptTime: null,
      code: null
    }
  }

  export default {
    name: "HistoryAudit",
    data() {
      return {
        uploadedFileId: null,
        timeRange: null,
        selectedWalletOrder: null,
        //标题
        topTitle: {
          title: '财务审核',
          subTit: '提现审核',
          thirdTit: '历史审核',
        },
        count_data: {
          rejectTotalCount: 0,
          rejectTotalFee: 0,
          delayTotalCount: 0,
          passTotalCount: 0,
          passTotalFee: 0,
          delayTotalFee: 0,
          pendingTotalCount: 0,
          pendingTotalFee: 0,
        },
        // 日期切换
        tabData: {
          textArr: ['今日', '昨日', '近7日', '近30日'],
          nowIndex: 0
        },
        // 表格搜索条件
        searchForm: this.$deepClone(searchConst),
        // 全部状态
        statusOptions: [
          {key: 0, label: '全部'},
          {key: 2, label: '未审核'},
          {key: 4, label: '已通过'},
          {key: 6, label: '已拒绝'},
          {key: 8, label: '延后处理'},
        ],
        // 所有审核人
        auditorOptions: [],
        // 弹窗数据
        postForm: Object.assign({}, defaultPostForm),
        // 添加/编辑窗口是否显示
        dialogFormVisible: false,
        // 弹窗标题
        dialogMap: {
          add: '添加提现转账凭证',
          edit: '编辑提现转账凭证'
        },
        dialogTitle: '',
        rules: {
          //凭证图片url
          certificatePicId: [{required: true, message: '请添加转账凭证', trigger: 'blur'}],
        },
        // 导入图片
        fileList: [],
        export_data: {},
        // 表格数据
        tableData: [],
        // 表格数据总数
        total: 0,
        // 日期时间选择器
        timePickerOptions: {
          disabledDate(time) {
            // return time.getTime() > Date.now();
          },
          shortcuts: [
            {
              text: '今天',
              onClick(picker) {
                // picker.$emit('pick', [new Date(), new Date()])
                const end = new Date()
                const start = new Date()
                start.setHours('00', '00', '00')
                end.setHours('23', '59', '59')
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '昨天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24)
                start.setHours('00', '00', '00')
                end.setHours('23', '59', '59')
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
                start.setHours('00', '00', '00')
                end.setHours('23', '59', '59')
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                start.setHours('00', '00', '00')
                end.setHours('23', '59', '59')
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                start.setHours('00', '00', '00')
                end.setHours('23', '59', '59')
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                start.setHours('00', '00', '00')
                end.setHours('23', '59', '59')
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        }
      }
    },
    computed: {
      min_accept_time() {
        return this.timeRange ? this.timeRange[0] : null
      },
      max_accept_time() {
        return this.timeRange ? this.timeRange[1] : null
      }
    },
    components: {
      SrFilter
    },
    created() {
      this.getDataList()
      this.loadDataCount()
    },
    methods: {
      // 上传文件
      onUpload(uploadObj) {
        let file = uploadObj.file
        let param = new FormData()
        param.append('file', file)
        uploadFile(param)
            .then(resp => {
              let uploadedFile = resp.data.uploadedFiles[0];
              this.uploadedFileId = uploadedFile.id
              this.selectedWalletOrder.certificatePicId = this.uploadedFileId
              this.postForm.certificatePicId = this.uploadedFileId
            })
            .catch(e => console.log(e))
      },

      // 文件上传成功时的钩子
      handleUploadSuccess(res, file) {
        console.log('Success-res', res)
        console.log('Success-file', file)
        this.postForm.imageUrl = URL.createObjectURL(file.raw);
      },
      // 文件上传失败时的钩子
      handleUploadError(res, file) {
        console.log('Error-res', res)
        console.log('Error-file', file)

        this.$message.error('凭证上传失败！')
        this.$alert('凭证上传失败！', '上传失败提示', {
          confirmButtonText: '确定',
          type: 'error',
          showClose: false,
          dangerouslyUseHTMLString: true
        })
      },
      // 上传文件之前的钩子(限制文件格式、文件大小),可在此处获取文件id
      beforeUpload(file) {
        console.log(file)
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;
        // console.log('file.type', file.type)
        // console.log('file.size', file.size)

        if (!isJPG && !isPNG) {
          // this.$message.error('上传图片只能是 JPG 格式!');
          this.$message.error('只能上传jpg/png文件!');
        }
        // if (!isLt2M) {
        //   this.$message.error('上传头像图片大小不能超过 2MB!');
        // }
        var b = isLt2M && (isJPG || isPNG);
        console.log(b)
        return b;
      },
      tableExport() {
        this.searchForm.params.minAcceptTime = this.min_accept_time
        this.searchForm.params.maxAcceptTime = this.max_accept_time
        const url = `${this.$baseNewUrl}esaleb-service-funds/audit/exportAuditDetails?accessToken=${this.$accessToken()}&${objectToQueryString(this.searchForm.params)}`;
        window.open(url, '_blank');
      },
      exportDetails(status) {
        this.export_data.statusList = status
        this.searchForm.params.minAcceptTime = this.min_accept_time
        this.searchForm.params.maxAcceptTime = this.max_accept_time
        const url = `${this.$baseNewUrl}esaleb-service-funds/audit/exportAuditDetails?accessToken=${this.$accessToken()}&${objectToQueryString(this.export_data)}`;
        window.open(url, '_blank');
        // window.open(`http://localhost:8080/esaleb-server/!Busi/Financial/Withdraw/~query/Q_WITHDRAW.Q_REVIEW_DETAILS?_exeresult=excel&${objectToQueryString(this.export_data)}`, '_blank');
      },
      formatDefault: function (date) {
        return formatDate(date, 'yyyyMMdd');
      },
      loadDataCount(params) {
        const date = new Date();
        const req = {
          status: [4, 6, 8],
          maxAcceptDate: params ? this.formatDefault(params.max_accept_date) : this.formatDefault(date),
          minAcceptDate: params ? this.formatDefault(params.min_accept_date) : this.formatDefault(date),
        }
        getTotalCount(req)
            .then(resp => {
              this.count_data = resp.data
            })
      },
      // 顶部日期切换
      tabLi(nowIndex) {
        this.tabData.nowIndex = nowIndex;
        console.log(nowIndex)
        // 0:'今日', 1:'昨日', 2:'近7日', 3:'近30日'
        let params = {}
        const date = new Date();
        switch (nowIndex) {
          case 0:
            params = {
              max_accept_date: date,
              min_accept_date: date,
            }
            this.loadDataCount()
            break
          case 1:
            date.setTime(date.getTime() - 24 * 60 * 60 * 1000);
            params = {
              max_accept_date: date,
              min_accept_date: date,
            }
            break;
          case 2:
            date.setTime(date.getTime() - 24 * 60 * 60 * 1000 * 6);
            params = {
              max_accept_date: new Date(),
              min_accept_date: date,
            }
            console.log(params)
            break;
          case 3:
            date.setTime(date.getTime() - 24 * 60 * 60 * 1000 * 29);
            params = {
              max_accept_date: new Date(),
              min_accept_date: date,
            }
            break;
          default:
            break;
        }

        this.export_data.maxAcceptDate = this.formatDefault(params.max_accept_date)
        this.export_data.minAcceptDate = this.formatDefault(params.min_accept_date)
        this.loadDataCount(params)
      },
      // 获取表格数据
      async getDataList() {
        this.searchForm.params.minAcceptTime = this.min_accept_time
        this.searchForm.params.maxAcceptTime = this.max_accept_time
        const result = await getHisReviewDetails(this.searchForm)
        try {
          this.tableData = result.data.records
          this.total = parseInt(result.data.total)
        } catch (e) {
          console.log(e)
        }
      },


      // 列表过滤查询
      handleSearch() {
        this.getDataList()
      },
      // 搜索重置（清空）
      handleReset() {
        // 初始化参数
        this.searchForm = this.$deepClone(searchConst)
        this.timeRange = ''
        this.getDataList()
      },
      // 列表每页条数变了
      handleSizeChange(val) {
        this.searchForm.size = val
        this.getDataList()
      },
      // 列表当前页码变了
      handleCurrentChange(val) {
        this.searchForm.current = val
        this.getDataList()
      },


      // 弹出手工添加“转账流水号”窗口
      showAddDialog(scope) {
        this.dialogTitle = 'add'
        this.dialogFormVisible = true
        this.selectedWalletOrder = this.$deepClone(scope.row)

        // this.postForm.action_type = null
      },
      // 弹出编辑“转账流水号”窗口
      showEditDialog(data) {
        this.dialogTitle = 'edit'
        this.dialogFormVisible = true
        // this.selectedWalletOrder = this.$deepClone(data.row)
        this.selectedWalletOrder = data.row
      },
      // 弹窗关闭前
      beforeClose() {
        this.resetData()
      },
      // 关闭弹窗
      closeDialog() {
        this.resetData()
      },
      // 重置表单
      resetData() {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
        this.postForm = Object.assign({}, defaultPostForm)
        // this.selectedWalletOrder = null
        this.uploadedFileId = null
      },

      // 验证表单-点击弹窗的“确定”按钮
      validateForm() {
        this.submitForm()
      },
      // 提交表单
      async submitForm() {
        if (!this.postForm.certificatePicId) {
          this.closeDialog()
          return;
        }
        try {
          this.postForm.code = this.selectedWalletOrder.code
          const result = await editCertificateAPI(this.postForm)
          this.$message.success('更新成功')
          this.postForm = null
          // 获取表格数据
          this.getDataList()
          this.closeDialog()
        } catch (e) {
          console.log(e)
          // this.$message.success('编辑失败' + e.message)
        }
      },
    },
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  /* 文字顔色 */
  /* 浅绿 */
  .blackText {
    color: #4E4A46;
  }

  .greenText {
    color: #2DBAA5;
  }

  .lightGText {
    color: #76C819;
    font-size: 14px;
  }

  .orangeText {
    color: #FA6241;
  }

  .grayText {
    color: #7F7F7F;
  }

  .maRi4 {
    margin-right: 4px;
    // max-width: 200px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
  }

  .historyAudit {
    min-width: 1080px;
  }

  // 标题
  .historyAudit .titleBox {
    width: 100%;
    background: #ffffff;
    height: 44px;
    padding: 0 9px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }

  .titleBox b {
    color: #2B2727;
    font-size: 15px;
  }

  .titleBox span {
    color: #7F7F7F;
    font-size: 13px;
  }

  .titleBox .titRiImg {
    width: 76px;
    height: 24px;
  }

  // tab切换-日期切换
  .historyAudit .tabBox {
    background: #fff;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }

  .tabBox li {
    float: left;
    width: 80px;
    color: #7F7F7F;
    font-size: 12px;
    cursor: pointer;
    position: relative;
  }

  .tabBox li.on {
    color: #F99A1A;
  }

  .tabBox li:after {
    content: '';
    position: absolute;
    width: 80px;
    height: 4px;
    background: transparent;
    bottom: -4px;
    left: 0;
  }

  .tabBox li.on:after {
    background: #F99A1A;
  }

  // 统计（三个模块）
  .historyAudit .totalBox {
    // width: 100%;
    margin-top: 16px;
    height: 111px;
  }

  .totalBox li {
    float: left;
    height: 111px;
    background: #fff;
    width: 32%;
    width: calc((100% - 24px) / 3);
    padding: 10px 10px 12px 12px;
    display: flex;
    flex-flow: column nowrap;
  }

  .totalBox li + li {
    margin-left: 12px;
  }

  .totalBox li .total_top {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }

  .totalBox li .total_top .top_le {
    display: flex;
    flex-flow: column nowrap;
  }

  .totalBox li .total_top .top_le .top_tit {
    height: 16px;
    line-height: 16px;
    font-size: 12px;
    color: #34333A;
    display: flex;
    flex-flow: row nowrap;
    // align-items: center;
  }

  .totalBox li .total_top .top_le .top_tit img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }

  .totalBox li .total_top .top_le .top_tip {
    height: 16px;
    line-height: 16px;
    margin-top: 7px;
    font-size: 12px;
    color: #AAAAAA;
  }

  .totalBox li .total_top .top_ri {
    width: 88px;
    height: 24px;
    cursor: pointer;
  }

  .totalBox li .total_top .top_ri img {
    width: 100%;
    height: 100%;
  }

  .totalBox li .total_money {
    height: 42px;
    line-height: 42px;
    margin-top: 6px;
    font-size: 32px;
  }

  // 历史审核标题
  .historyAudit .titleLine {
    width: 100%;
    height: 20px;
    margin-top: 12px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }

  .titleLine span {
    height: 20px;
    line-height: 20px;
    font-size: 15px;
    font-weight: bold;
    color: #2B2727;
  }

  .titleLine span::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 20px;
    margin-right: 6px;
    background: #FA6241;
    vertical-align: middle;
  }

  // 筛选框
  .historyAudit .searchBox {
    // height: 64px;
    margin-top: 12px;
    // background: #ffffff;
  }

  // 表格
  .historyAudit .botTable {
    margin-top: 12px;
    width: 100%;
    // max-height: 408px;
  }

  .botTable .tableTop {
    height: 54px;
    padding: 0 12px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
  }

  .botTable .tableTop .top_le {
    font-size: 15px;
    font-weight: bold;
    color: #4E4A46;
  }

  .botTable .tableTop .exportBtn {
    width: 72px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-radius: 4px;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

  .botTable .tableTop .exportBtn .exportIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
    background-size: 14px 14px;
  }

  /* 分页条 */
  .pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
  }

  // 弹窗按钮-取消按钮
  .cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
  }

  // 弹窗按钮-橙色按钮
  .refuseOBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #FA6241;
    color: #FFFFFF;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }


</style>
